import moment from 'moment';
import dayjs from 'dayjs';

export function dateFormat(date) {
    if (date) {
        return dayjs(date).format("DD-MM-YYYY")
    }
    return date;
}

export function shortDateFormat(date) {
    if (date) {
        return dayjs(date).format("DD-MM-YY")
    }
    return date;
}